import React from 'react';
import {
  SEO,
  BrazilianHero,
  HowBrazilianWork,
  LaserForBrazilian,
  BrazilianWaxCostDivider,
  SectionDivider,
} from '../../components';
import { graphql } from 'gatsby';

function BrazilianPage() {
  return (
    <main id='brazilian-page'>
      <BrazilianHero />
      <BrazilianWaxCostDivider />
      <HowBrazilianWork />
      <SectionDivider />
      <LaserForBrazilian />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`Brazilian Style Laser Hair Removal | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
      description='Experience the luxury of Brazilian laser hair removal for silky, hair-free skin. Say hello to a smoother you. Book your appointment today!'
    />
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default BrazilianPage;
